export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_SINGLE_PROPERTY = 'GET_SINGLE_PROPERTY'
export const GET_ALL_DYNAMIC_ARRAY = 'GET_ALL_DYNAMIC_ARRAY'
export const GET_ALL_TABLE_VALUES = 'GET_ALL_TABLE_VALUES'
export const GET_ALL_DYNAMIC_VALUES = 'GET_ALL_DYNAMIC_VALUES'
export const GET_ALL_DYNAMIC_TABLES = 'GET_ALL_DYNAMIC_TABLES'
